"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Head = Head;
const jsx_runtime_1 = require("react/jsx-runtime");
const canonicals_1 = require("../../utils/canonicals");
const Seo_1 = require("./Seo");
const VwoScripts_1 = require("./VwoScripts");
const buildSeoSchema_1 = require("../../utils/buildSeoSchema");
function Head({ pageContext: { packages, page: { title, pagePath, description, robots, canonical, schemaType, customSchema, overrideSchema, mainEntity, spanish, }, }, data: { site: { siteMetadata: { alternateName, siteURL, siteName, vwoProjectID }, }, }, }) {
    const fallbackTitle = `${pagePath
        .replace(/^\/|\/+/g, '-')
        .replace(/^-/g, '')}-page`;
    const formattedCanonical = (0, canonicals_1.getCanonical)(siteURL, pagePath, canonical);
    const formattedSchema = (0, buildSeoSchema_1.buildSeoSchema)({
        alternateName,
        title: title || '',
        description: description || '',
        schemaType: schemaType || '',
        mainEntity,
        customSchema,
        override: overrideSchema || false,
        siteName,
        siteURL,
        packages
    });
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Seo_1.SEO, { title: title || fallbackTitle, description: description, robots: robots, canonical: formattedCanonical, customSchema: formattedSchema, lang: spanish ? 'es-US' : 'en-US' }), (0, jsx_runtime_1.jsx)(VwoScripts_1.VwoScripts, { vwoId: vwoProjectID })] }));
}
